import de from "./locales/de";
import gb from "./locales/gb";

export default {
    de: de,
    gb: gb
}